module.exports = __webpack_public_path__ + "guinea-bissau.svg?e1d3421a83cdaab7adeecbd4e113c3a7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/guinea-bissau.svg
// module id = 182
// module chunks = 10